var exports = {
  "k": "xe7b6e3d6--5d1038--container",
  "I": "xe7b6e3d6--5d1038--logo_img",
};

module.exports = exports;
